"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _find = _interopRequireDefault(require("lodash/find"));
var _map = require("../map");
var _Vector = _interopRequireDefault(require("ol/layer/Vector"));
var _Feature = _interopRequireDefault(require("ol/Feature"));
var _Point = _interopRequireDefault(require("ol/geom/Point.js"));
var _Projection = _interopRequireDefault(require("ol/proj/Projection.js"));
var _proj = require("ol/proj");
var _Vector2 = _interopRequireDefault(require("ol/source/Vector.js"));
var _Style = _interopRequireDefault(require("ol/style/Style.js"));
var _Icon = _interopRequireDefault(require("ol/style/Icon.js"));
var _Circle = _interopRequireDefault(require("ol/style/Circle.js"));
var _Text = _interopRequireDefault(require("ol/style/Text.js"));
var _Fill = _interopRequireDefault(require("ol/style/Fill.js"));
var _Stroke = _interopRequireDefault(require("ol/style/Stroke.js"));
var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON.js"));
var _MBTAT = _interopRequireDefault(require("../../../../assets/icons/MBTA-T.png"));
var _bus = _interopRequireDefault(require("../../../../assets/icons/bus.png"));
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _lodash = require("lodash");
var _constants = require("../../../lib/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// import ol from "openlayers";

var layer = new _Vector["default"]({
  visible: true,
  name: "crossings",
  minZoom: _constants.CROSSINGS_ZOOM,
  zIndex: _constants.CROSSINGS_Z_LEVEL,
  updateWhileAnimating: true,
  updateWhileInteracting: true,
  style: new _Style["default"]({
    image: new _Circle["default"]({
      radius: 7,
      fill: new _Fill["default"]({
        color: '#00aac3'
      })
    })
  })
});
_map.map.addLayer(layer);
var Crossings = {
  handleUpdate: function handleUpdate(props) {
    var crossings = props.crossings;
    if (!crossings || !crossings.type) return;
    var features = new _GeoJSON["default"]({
      featureProjection: 'EPSG:3857'
    }).readFeatures(crossings);
    layer.setSource(new _Vector2["default"]({
      features: features
    }));
  },
  getOverlay: function getOverlay(crossingId, crossingsGeoJson) {
    var features = crossingsGeoJson.features;
    var crossing = (0, _find["default"])(features, function (feat) {
      return feat.id === crossingId;
    });
    if (!crossing) {
      return null;
    }

    // set position
    var coords = crossing.geometry.coordinates;
    _map.overlay.setPosition((0, _proj.transform)([coords[0], coords[1]], "EPSG:4326", "EPSG:900913"));
    _map.overlay.setProperties({
      layer: "crossings",
      crossingId: crossingId
    });
    // output rendered content
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "overlay-content basic"
    }, Object.keys(crossing.properties).map(function (key) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontSize: 10,
          display: 'block'
        },
        key: key
      }, key, ": ", crossing.properties[key]);
    }));
  }
};
var _default = Crossings;
exports["default"] = _default;